// The shape of a Google Cloud region's name: words of lowercase letters
// joined by hyphens, then a number, as in `us-central1` and
// `northamerica-northeast2`. Nothing P0 has lists the regions Cloud Run is
// in, so this keeps out what can't be one, such as a zone (`us-central1-a`)
// or an AWS region (`us-west-2`), and takes a region that doesn't exist.
const GCP_REGION_PATTERN = /^[a-z]+(?:-[a-z]+)+\d+$/;

export const INVALID_GCP_REGION =
  "Enter the Google Cloud region the connector runs in, such as us-central1.";

/** Whether `region`, ignoring surrounding whitespace, has the shape of a
 * Google Cloud region's name. */
export const isGcpRegion = (region: unknown): region is string =>
  typeof region === "string" && GCP_REGION_PATTERN.test(region.trim());
